import {
  Article,
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { MediaItemCardLCSubItem } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardLocalCombination/MediaItemCardLCSubItem/MediaItemCardLCSubItem";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { useItemInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemInfo";
import { ItemStockInfo } from "@coworker/apprestructured/src/shared/hooks/item/useItemStock";
import SimpleArticleCardSkeleton from "@coworker/apprestructured/src/shared/simple/SimpleSkeleton/SimpleArticleCardSkeleton";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import styles from "./local-combinations-items-list-view-item.module.css";

interface LocalCombinationsItemsListViewItemProps {
  itemNo: string;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  badges4AK1?: string[];
  itemTags?: string[];
  article: Article;
  totalQuantityPieces: number;
  mediaItemViewType?: MediaItemViewType;
  stockInfo?: ItemStockInfo;
}

export const LocalCombinationsItemsListViewItem = ({
  itemNo,
  edsData,
  salesStopData,
  badges4AK1,
  itemTags,
  article,
  totalQuantityPieces,
  mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
  stockInfo,
}: LocalCombinationsItemsListViewItemProps) => {
  const { data: itemInfo, isLoading } = useItemInfo(itemNo);
  return (
    <div className={styles["lc-items-list-view-item"]}>
      {isLoading && <SimpleArticleCardSkeleton />}
      {!isLoading && itemInfo && (
        <MediaItemCardLCSubItem
          stockInfo={stockInfo}
          itemCardRenderType={ItemCardRenderType.link}
          edsData={edsData}
          salesStopData={salesStopData}
          badges4AK1={badges4AK1}
          itemTags={itemTags}
          itemInfo={itemInfo}
          article={article}
          totalQuantityPieces={totalQuantityPieces}
          mediaItemViewType={mediaItemViewType}
        />
      )}
    </div>
  );
};
